import { CONFIG_LAYER } from './config';
import { CONFIG_LAYER_AU } from './config-au';
import { DCR } from './dcr';

export const environment = {
	production: true,
	offline: false,
	dcr: DCR,
	config: CONFIG_LAYER,
	config_au: CONFIG_LAYER_AU,
	oktaConfig: {
		test: {
			clientId: '0oaz5bbc8fTAPvFoo0h7',
			issuer: 'https://test-login.blackrock.com/oauth2/ausv0a8pviCRJO8f10h7',
			redirectUri: 'https://testc.blackrock.com/blk-one01/login/oauth2/callback/authz.oajs'
		},
		preview: {
			clientId: '0oagr7ogbnbZnuDZi357',
			issuer: 'https://login.blackrock.com/oauth2/ausgr8lm5mbyQmcAQ357',
			redirectUri: 'https://preview.blackrock.com/blk-one01/login/oauth2/callback/authz.oajs'
		},
		blackrock: {
			clientId: '0oagr7ogbnbZnuDZi357',
			issuer: 'https://login.blackrock.com/oauth2/ausgr8lm5mbyQmcAQ357',
			redirectUri: 'https://www.blackrock.com/blk-one01/login/oauth2/callback/authz.oajs'
		}
	}
};
